import { getBannerList } from "@/api/banner";
const state = {
  module: {},
  banner: {},
};
const mutations = {
  SET_MODULE(state, module) {
    state.module = module;
  },
  SET_BANNER(state, data) {
    state.banner = data;
  },
};
const actions = {
  setModule({ commit }, data) {
    commit("SET_MODULE", data);
  },
  async getBanner({ commit }, data) {
    const res = await getBannerList(data);
    commit("SET_BANNER", res.data.results[0]);
  },
};
export default {
  state,
  mutations,
  actions,
};
